import { useEffect } from "react";
import { TRexLogo } from "../components/TRexLogo";
import { useAuth } from "../contexts/AuthContext";
import { Navigate } from "react-router-dom";

export default function AdminLogin() {
  const { user, loading } = useAuth();

  useEffect(() => {
    document.body.classList.add("admin-body");
    return () => document.body.classList.remove("admin-body");
  }, []);

  if (loading) return null;
  if (user) return <Navigate to="/admin" replace />;

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="admin-shell min-h-screen bg-bone flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center">
          <div className="inline-flex items-center justify-center h-14 w-14 rounded-full bg-aubergine">
            <TRexLogo className="h-7 w-7" color="#E8D9B8" />
          </div>
          <h1 className="mt-6 font-serif text-3xl text-aubergine">
            T-REX Admin <em className="accent-italic">console</em>
          </h1>
          <p className="mt-3 text-sm text-aubergine/60">
            Sign in with Google to manage articles, media, and contact submissions.
          </p>
        </div>

        <div className="mt-10 rounded-lg border border-aubergine/10 bg-white p-6 shadow-sm">
          <button
            onClick={handleLogin}
            data-testid="admin-login-google-button"
            className="w-full inline-flex items-center justify-center gap-3 rounded-md bg-aubergine text-bone hover:bg-aubergine/90 px-4 py-3 font-mono text-xs tracking-[0.04em] transition-all"
          >
            <svg className="h-4 w-4" viewBox="0 0 24 24" aria-hidden="true">
              <path fill="#FFFFFF" d="M21.35 11.1h-9.17v2.96h5.36c-.23 1.46-1.62 4.28-5.36 4.28-3.23 0-5.86-2.67-5.86-5.96s2.63-5.96 5.86-5.96c1.84 0 3.07.78 3.78 1.46l2.57-2.47C16.99 3.5 14.83 2.5 12.18 2.5 6.91 2.5 2.64 6.78 2.64 12s4.27 9.5 9.54 9.5c5.51 0 9.16-3.87 9.16-9.32 0-.63-.07-1.1-.15-1.58z" />
            </svg>
            Sign in with Google
          </button>
          <p className="mt-4 text-xs text-aubergine/55 text-center">
            Only emails on the admin allowlist can access this console.
          </p>
        </div>

        <p className="mt-8 text-center text-[11px] font-mono uppercase tracking-[0.15em] text-aubergine/40">
          <a href="/" data-testid="admin-login-back-home" className="hover:text-aubergine transition-colors">← Back to website</a>
        </p>
      </div>
    </div>
  );
}
